/* eslint-disable */
// src/routes.js
import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from './App';
import ConfigD from './components/util/ConfigD';
import ConsultarProtocolo from './components/ConsultarProtocolo';
import SolicitarAutorizacao from './components/SolicitarAutorizacao';
import Autenticar from './components/Autenticar';
import RecuperarProtocolo from './components/RecuperarProtocolo';
import CadastrarProtocolo from './components/CadastrarProtocolo';
import CadastrarProtocoloUPP from './components/CadastrarProtocoloUPP';
import VisualizarProtocolo from './components/VisualizarProtocolo';
import ProtocoloCadastrado from './components/ProtocoloCadastrado';
import Dashboard from './components/DashboardPage';
import RatingForm from './components/RatingForm';
import RatingFormTF from './components/RatingFormTF';
import RatingFormTFN from './components/RatingFormTF';
import RatingFormTFE from './components/RatingFormTF';
import MainBody from './components/MainBody';
import Erro from './components/Erro';
const NotFound = () => <Erro mensagemErro='Página não encontrada!' />

export default (
    <Route path={ConfigD.getServerBase() === '' ? '/' : ConfigD.getServerBase()} component={App}>
        <IndexRoute component={CadastrarProtocolo} />
        <Route path={ConfigD.getServerBase() + '/consultarProtocolo'} component={ConsultarProtocolo} />
        <Route path={ConfigD.getServerBase() + '/solicitarAutenticacao'} component={SolicitarAutorizacao} />
        <Route path={ConfigD.getServerBase() + '/autenticar/:token'} component={Autenticar} />
        <Route path={ConfigD.getServerBase() + '/recuperarProtocolo'} component={RecuperarProtocolo} />
        
        <Route path={ConfigD.getServerBase() + '/cadastrarProtocolo'} component={CadastrarProtocolo} />
        <Route path={ConfigD.getServerBase() + '/dashboard'} component={Dashboard} />
        <Route path={ConfigD.getServerBase() + '/cadastrarProtocolo/:canal/:grupo/:natureza'} component={CadastrarProtocolo} />
        <Route path={ConfigD.getServerBase() + '/cadastrarProtocolo/:canal/:grupo/:natureza/:uf'} component={CadastrarProtocolo} />
        {/* Atalho /UPP: injeta os params do canal 'upp' (regras em CadastrarProtocoloForm.js) */}
        <Route path={ConfigD.getServerBase() + '/UPP'} component={CadastrarProtocoloUPP} />
        <Route path={ConfigD.getServerBase() + '/visualizarProtocolo'} component={VisualizarProtocolo} />
        <Route path={ConfigD.getServerBase() + '/protocoloCadastrado'} component={ProtocoloCadastrado} />
        {/* Formulário novo para campanha estatica */}
        <Route path={ConfigD.getServerBase() + '/pesquisa/:idCampanha'} component={RatingFormTFN} />
        {/* Formulário novo para campanha com token enviado por email */}
        {/* <Route path={ConfigD.getServerBase() + '/ratingTF/:idCampanha/:token'} component={RatingFormTF} /> */}
        {/* Formulário novo para campanha com identificação da estrutura */}
        <Route path={ConfigD.getServerBase() + '/ratingTFE/:idCampanha/:idEstrutura'} component={RatingFormTFE} />
        {/* Formulário novo para campanha com token enviado por email */}
        <Route path={ConfigD.getServerBase() + '/ratingTFMail/:idCampanha/:token/:voto'} component={RatingFormTF} />
        <Route path={ConfigD.getServerBase() + '/rating/:idCampanha'} component={RatingForm} />
        <Route path={ConfigD.getServerBase() + '/rating/:idCampanha/:token'} component={RatingForm} />
        <Route path="*" component={NotFound} />
    </Route>
);




/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/